import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { Card, CardHeader, Button, PageContainer } from '../components/ui';
import { useLanguage } from '../context/LanguageContext';

export default function SimulationPhishingIntro() {
  const { organizationId } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const points = Array.isArray(t.phishingSimPoints) ? t.phishingSimPoints : [];

  return (
    <Layout>
      <PageContainer>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-[#0f172a] dark:text-slate-100 tracking-tight">
            {t.phishingSimIntro}
          </h1>
          <p className="text-[#475569] dark:text-slate-400 mt-1">
            {t.understandBeforeStart}
          </p>
        </div>

        <Card className="overflow-hidden max-w-3xl">
          <CardHeader title={t.whatWillBeSimulated} subtitle={t.phishingIntroSubtitle} />
          <div className="p-6 space-y-5">
            <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
              {t.phishingSimDesc}
            </p>

            <ul className="space-y-2 text-sm text-slate-600 dark:text-slate-300">
              {points.map((point, index) => (
                <li key={`${point}-${index}`} className="flex gap-2">
                  <span className="text-[#0ea5e9] mt-0.5">•</span>
                  <span>{point}</span>
                </li>
              ))}
            </ul>

            <div className="rounded-lg bg-amber-100 dark:bg-amber-500/15 border border-amber-200 dark:border-amber-500/30 p-4 text-sm text-amber-800 dark:text-amber-300">
              <strong>{t.attention}:</strong> {t.phishingAttention}
            </div>

            <div className="rounded-lg border border-slate-200 dark:border-slate-700 p-4">
              <p className="text-xs text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-2">
                {t.prerequisites}
              </p>
              <p className="text-sm text-slate-600 dark:text-slate-300">
                {t.phishingPrerequisitesText}
              </p>
            </div>

            <div className="flex flex-wrap gap-3 pt-1">
              <Button onClick={() => navigate(`/org/${organizationId}/phishing-manual`)}>
                {t.startSimulation}
              </Button>
              <Link to={`/org/${organizationId}/simulations`}>
                <Button variant="secondary">{t.back}</Button>
              </Link>
            </div>
          </div>
        </Card>
      </PageContainer>
    </Layout>
  );
}
